<template>
  <div style="height:100%;background:#003D66;color:#ffffff">
   <Head></Head>
    <div
      style="background:#FFFFFF;position:fixed;top:4.5rem;left:0;z-index: 999;height: 100%;width:100%;overflow: auto;font-size:18px;"
    >
      <div style="background:#003D66;padding:20px">
        <p
          style="font-weight: 600;font-size: 30px;line-height: 17px;color: #FFFFFF;"
        >
          {{ $t("Energy saving overview") }}
        </p>
        <a-row
          style="width:100%;display:flex;justify-content: space-between;padding-top:20px"
        >
          <a-col
            :span="5"
            style="background:#EBEFF2;display:flex;align-content: space-between;flex-wrap: wrap;padding:10px;box-sizing: border-box;border-radius: 4px;"
            v-for="(a, index) in topDataTop"
            :key="index"
          >
            <div
              style="width:100%;display: flex;flex-direction: column;
    justify-content: space-between;
    height: 100%;"
            >
              <div
                style="width:100%;color:#606163;font-size: 24px;display:flex;justify-content:space-between"
              >
                <div>
                  {{ a.title }}
                </div>
                <img
                  style="width: 48px;height: 48px;margin-left:10px"
                  :src="a.imgurl"
                  alt=""
                />
              </div>
              <div
                style="width:100%;display:flex;justify-content:start;align-items: baseline;"
              >
                <span
                  style="font-size: 38px;color:#3A4D59;font-weight: 500;padding-right:5px"
                  >{{ a.value.num }}</span
                >
                <div style="color:#606163;margin-left:10px">
                  <div style="color:#E15C5E;font-size:14px">
                    {{ a.value.unit }}
                  </div>
                  <div>{{ a.value.unit1 }}</div>
                </div>
              </div>
              <div
                style="width:100%;display:flex;align-items:baseline;font-size: 16px;color:#606163;"
              >
                <div>{{ a.text }}</div>
                <div style="color:#495057;font-size:18px;margin-left:10px">
                  {{ a.subtext }}
                </div>
                <div
                  v-if="index == 1"
                  style="margin-left:5px;display:flex;align-items:baseline"
                >
                  <div style="margin-right:5px">✖️</div>
                  <div>{{ $t("Electricity price today") }}</div>
                </div>
                <div
                  v-if="index == 2"
                  style="margin-left:5px;display:flex;align-items:baseline"
                >
                  <div style="margin-right:5px">✖️</div>
                  <div>{{ $t("CO2 price today") }}</div>
                </div>
                <div
                  v-show="index == 0"
                  style="margin-left:5px;display:flex;align-items:baseline;opacity: 0;"
                >
                  <div style="margin-right:5px">✖️</div>
                  <div>{{ $t("CO2 price today") }}</div>
                </div>
              </div>
            </div>
          </a-col>
        </a-row>
      </div>
      <div style="background:#FFFFFF;padding:20px">
        <p
          style="font-weight: 600;font-size: 30px;line-height: 17px;color: #495057;margin-top:20px"
        >
          {{ $t("UN energy saving analysis") }}
        </p>
        <div style="width: 100%;margin-top:20px;height:550px">
          <a-row
            style="color:#000000;height:550px;display: flex;justify-content:space-between"
          >
            <a-col
              span="7"
              style="display:flex;background: #EBEFF2;box-shadow: 0 1px 2px rgba(56, 65, 74, 0.14902);height:100%;padding:20px 10px;align-items:center;border-radius: 4px;"
            >
              <div style="height:100%">
                <div style="font-size: 20px;color: #606163;">
                  <span
                    :style="{
                      display: $i18n.locale != 'ch' ? 'block' : 'inline-block'
                    }"
                    >{{ $t("Operating status") }}：</span
                  ><span style="color:#35D283">{{ $t("Energy saving") }}</span>
                </div>
                <div
                  :style="{
                    height:
                      $i18n.locale != 'ch'
                        ? 'calc(100% - 60px)'
                        : 'calc(100% - 20px)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }"
                >
                  <img
                    style="width: 249px;height: 269.54px;"
                    src="./干泵9.png"
                    alt=""
                  />
                </div>
              </div>

              <a-row
                style="width:100%;height:calc(550px - 40px);color: #3E4043;line-height:60px;font-weight:500;background:#fff;font-size:19px"
              >
                <a-col
                  span="24"
                  style="color: #495057;font-weight:600;font-size:24px;padding-left:10px"
                >
                  {{ $t("Unit Information") }}</a-col
                >
                <a-col
                  span="24"
                  class="info-bg"
                  style="padding-left:10px;display: flex;align-items: center;justify-content: space-between;text-align: left;height: calc((550px - 40px - 60px ) / 6);"
                >
                  <div style="width:35%;line-height: 24px;">
                    {{ $t("Name") }}
                  </div>
                  <div
                    class="info-bg"
                    style="width:65%;text-align: left;margin-left:10px;line-height: 20px;"
                  >
                    {{ $t("Intelligent Dry Hybrid Vacuum Unit") }}
                  </div>
                </a-col>

                <a-col
                  span="24"
                  style="padding-left:10px;display: flex;align-items: center;justify-content: space-between;text-align: left;height: calc((550px - 40px - 60px ) / 6);"
                >
                  <div style="width:35%;line-height: 24px;">
                    {{ $t("Type") }}
                  </div>
                  <div
                    style="width:65%;text-align: left;margin-left:10px;line-height: 20px;"
                  >
                    VSD420/1200
                  </div>
                </a-col>

                <a-col
                  span="24"
                  class="info-bg"
                  style="padding-left:10px;display: flex;align-items: center;justify-content: space-between;text-align: left;height: calc((550px - 40px - 60px ) / 6);"
                >
                  <div style="width:35%;line-height: 24px;">
                    {{ $t("Suction flow") }}
                  </div>
                  <div
                    class="info-bg"
                    style="width:65%;text-align: left;margin-left:10px;line-height: 20px;"
                  >
                    300-2000 m3/h
                  </div>
                </a-col>

                <a-col
                  span="24"
                  style="padding-left:10px;display: flex;align-items: center;justify-content: space-between;text-align: left;height: calc((550px - 40px - 60px ) / 6);"
                >
                  <div style="width:35%;line-height: 24px;">
                    {{ $t("Extreme Vacuum") }}
                  </div>
                  <div
                    style="width:65%;text-align: left;margin-left:10px;line-height: 20px;"
                  >
                    10^-3 mbarA
                  </div>
                </a-col>

                <a-col
                  span="24"
                  class="info-bg"
                  style="padding-left:10px;display: flex;align-items: center;justify-content: space-between;text-align: left;height: calc((550px - 40px - 60px ) / 6);"
                >
                  <div style="width:35%;line-height: 24px;">
                    {{ $t("Back pressure") }}
                  </div>
                  <div
                    class="info-bg"
                    style="width:65%;text-align: left;margin-left:10px;line-height: 20px;"
                  >
                    ATM～1200 mbarA
                  </div>
                </a-col>

                <a-col
                  span="24"
                  style="padding-left:10px;display: flex;align-items: center;justify-content: space-between;text-align: left;height: calc((550px - 40px - 60px ) / 6);"
                >
                  <div style="width:35%;line-height: 24px;">
                    {{ $t("Equipment running time") }}
                  </div>
                  <div
                    style="width:65%;text-align: left;margin-left:10px;line-height: 20px;"
                  >
                  -  <!-- {{ $t("362 Days 20 Hours") }} -->
                  </div>
                </a-col>
              </a-row>
            </a-col>
            <a-col
              span="10"
              style="background: #EBEFF2;box-shadow: 0px 1px 2px rgba(56, 65, 74, 0.14902);height:100%;padding:20px 10px;align-items:center;border-radius: 4px;padding:20px"
            >
              <div style="background:#fff;width:100%;height:100%;">
                <p
                  style="font-weight: 400;font-size: 20px;color: #495057;padding: 20px 20px 0;"
                >
                  {{ $t("UN energy saving chart") }}
                </p>

                <div style="width:100%;height:440px" id="chart7"></div>
              </div>
            </a-col>
            <a-col span="6" style="height:100%">
              <a-row
                style="height:100%;display: flex;flex-wrap:wrap;box-sizing: border-box;"
              >
                <a-col
                  style="height:49%;background: #EBEFF2;box-shadow: 0px 1px 2px rgba(56, 65, 74, 0.14902);border-radius: 4px;margin: 5px;box-sizing: border-box;margin-top:0px"
                  span="11"
                >
                  <div style="padding:10px;display: flex;height:100%">
                    <div
                      style="display:flex;align-content:space-between;height:100%;flex-wrap:wrap"
                    >
                      <div
                        style="width:100%;font-weight: 500;font-size: 20px;color: #606163;display:flex;"
                      >
                        <p style="width:80%;min-height:60px">
                          {{ $t("Savings on electricity 30d") }}
                        </p>
                        <img
                          style="width: 48px;height: 48px;margin-left:10px"
                          src="./Iconshandian.png"
                          alt=""
                        />
                      </div>
                      <div
                        style="width:100%;font-weight: 500;font-size: 38px;color: #606163;"
                      >
                        1,155
                        <span style="font-size:20px">{{ $t("Rmb") }}</span>
                      </div>
                      <div
                        style="width:100%;font-size:14px;display: flex;justify-content:end;"
                      >
                        <span
                          style="color:#495057;padding-right:5px;font-size: 16px;"
                          >{{ $t("link relative ratio") }}</span
                        ><span style="color:#F8C14E">+6%</span>
                      </div>
                    </div>
                  </div>
                </a-col>
                <a-col
                  style="height:49%;background: #EBEFF2;
box-shadow: 0 1px 2px rgba(56, 65, 74, 0.14902);border-radius: 4px;margin: 5px;box-sizing: border-box;margin-top:0"
                  span="11"
                  ><div style="padding:10px;display: flex;height:100%">
                    <div
                      style="display:flex;align-content:space-between;height:100%;flex-wrap:wrap"
                    >
                      <div
                        style="width:100%;font-weight: 500;font-size: 20px;color: #606163;display:flex;"
                      >
                        <p style="width:80%;min-height:60px">
                          {{ $t("CO2 emissions reduced 30d") }}
                        </p>
                        <img
                          style="width: 45.01px;height: 48px;margin-left:10px"
                          src="./paiqiIcon.png"
                          alt=""
                        />
                      </div>
                      <div
                        style="width:100%;font-weight: 500;font-size: 38px;color: #606163;"
                      >
                        1.97 <span style="font-size:20px">{{ $t("Ton") }}</span>
                      </div>
                      <div
                        style="width:100%;font-size:14px;display: flex;justify-content:end;height:21px"
                      >
                        <span style="color:#495057;padding-right:5px;"></span
                        ><span style="color:#3A9B9A"></span>
                      </div>
                    </div></div
                ></a-col>
                <a-col
                  style="height:49%;background: #EBEFF2;box-shadow: 0 1px 2px rgba(56, 65, 74, 0.14902);border-radius: 4px;margin: 5px;box-sizing: border-box;"
                  span="11"
                  ><div style="padding:10px;display: flex;height:100%">
                    <div
                      style="display:flex;align-content:space-between;height:100%;flex-wrap:wrap"
                    >
                      <div
                        style="width:100%;font-weight: 500;font-size: 20px;color: #606163;display:flex;"
                      >
                        <p style="width:80%;min-height:60px">
                          {{ $t("Electricity bill 30d") }}
                        </p>
                        <img
                          style="width: 48px;height: 48px;margin-left:10px"
                          src="./shandian2.png"
                          alt=""
                        />
                      </div>
                      <div
                        style="width:100%;font-weight: 500;font-size: 38px;color: #606163;"
                      >
                        2,145
                        <span style="font-size:20px">{{ $t("Rmb") }}</span>
                      </div>
                      <div
                        style="width:100%;font-size:14px;display: flex;justify-content:end;"
                      >
                        <span
                          style="color:#495057;padding-right:5px;font-size: 16px;"
                          >{{ $t("link relative ratio") }}</span
                        ><span style="color:#3A9B9A">-5%</span>
                      </div>
                    </div>
                  </div></a-col
                >
                <a-col
                  style="height:49%;background: #EBEFF2;
box-shadow: 0 1px 2px rgba(56, 65, 74, 0.14902);border-radius: 4px;margin: 5px;box-sizing: border-box;"
                  span="11"
                  ><div style="padding:10px;display: flex;height:100%">
                    <div
                      style="display:flex;align-content:space-between;height:100%;flex-wrap:wrap"
                    >
                      <div
                        style="width:100%;font-weight: 500;font-size: 20px;color: #606163;display:flex;"
                      >
                        <p style="width:80%;min-height:60px">
                          {{ $t("CO2 emissions 30d") }}
                        </p>
                        <img
                          style="width: 45.01px;height: 48px;margin-left:10px"
                          src="./paiqiIcon.png"
                          alt=""
                        />
                      </div>
                      <div
                        style="width:100%;font-weight: 500;font-size: 38px;color: #606163;"
                      >
                        3.65 <span style="font-size:20px">{{ $t("Ton") }}</span>
                      </div>
                      <div
                        style="width:100%;font-size:14px;display: flex;justify-content:end;height:21px"
                      >
                        <span style="color:#495057;padding-right:5px;"></span
                        ><span style="color:#3A9B9A"></span>
                      </div>
                    </div></div
                ></a-col>
              </a-row>
            </a-col>
          </a-row>
        </div>
        <!-- <p
          style="font-weight: 600;font-size: 30px;line-height: 17px;color: #495057;margin-top:40px"
        >
          2022-08 {{$t("Monthly electricity")}}
        </p> -->
        <!-- <div
          style="width:100%;display:flex;justify-content: space-around;padding-top:20px"
        >
          <div
            style="width:19%;height:150px;background:#EBEFF2;display:flex;align-content: space-between;
            flex-wrap: wrap;padding:10px;box-sizing: border-box;border-radius: 4px;"
            v-for="(a, index) in topData" :key="index"
          >
            <div
              style="width:100%;color:#606163;font-size: 24px;display:flex;justify-content:space-between"
            >
              <div>
                {{ a.title }}
              </div>
              <img
                v-show="index == 0"
                style="width: 48px;height: 48px;margin-left:10px"
                src="./Iconshandian.png"
                alt=""
              />
              <img
                v-show="index == 1"
                style="width: 48px;height: 48px;margin-left:10px"
                src="./dollar.png"
                alt=""
              />
              <img
                v-show="index == 2"
                style="width: 48px;height: 48px;margin-left:10px"
                src="./Icon6.png"
                alt=""
              />
              <img
                v-show="index == 3"
                style="width: 48px;height: 48px;margin-left:10px"
                src="./Iconshandian.png"
                alt=""
              />
              <img
                v-show="index == 4"
                style="width: 48px;height: 48px;margin-left:10px"
                src="./Iconshandian.png"
                alt=""
              />
            </div>
            <div
              style="width:100%;display:flex;justify-content:center;align-items: center;"
            >
              <span
                style="font-size: 38px;color:#3A4D59;font-weight: 500;padding-right:5px"
                >{{ a.value.num }}</span
              >
              <div style="color:#606163">
                <div style="color:#E15C5E;font-size:14px">
                  {{ a.value.unit }}
                </div>
                <div>{{ a.value.unit1 }}</div>
              </div>
            </div>
            <div
              style="width:100%;display:flex;justify-content:space-between;font-size: 16px;"
            >
              <div>
                <span style="color:#1E1E1E;padding-right:5px">{{$t("Year-on-year")}}</span>
                <span style="color:#3A9B9A">{{ a.same }} %</span>
              </div>
              <div>
                <span style="color:#1E1E1E;padding-right:5px">{{$t("link relative ratio")}}</span
                ><span style="color:#3A9B9A">{{ a.sequential }}%</span>
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <div style="width:100%;padding:20px;margin-bottom:60px;height:600px">
        <p
          style="font-weight: 600;font-size: 30px;line-height: 17px;color: #495057;"
        >
          {{ $t("UN monitoring and analysis") }}
        </p>
        <div
          style="width:100%;height:100%;border: 10px solid rgb(235, 239, 242);border-radius: 4px;"
        >
          <div style="width:100%;height:500px" id="chart6"></div>
        </div>
      </div>
      <div style="height:100px"></div>
    </div>
  </div>
</template>
<script>
import { chart6, chart7 } from "./chart";
export default {
  name: "EnergyConsumption",
  data() {
    return {
      data6: {
        zh: [
          "08月10日",
          "08月11日",
          "08月12日",
          "08月13日",
          "08月14日",
          "08月15日",
          "08月16日",
          "08月17日",
          "08月18日",
          "08月19日",
          "08月20日",
          "08月21日"
        ],
        en: [
          "August 10",
          "August 11",
          "August 12",
          "August 13",
          "August 14",
          "August 15",
          "August 16",
          "August 17",
          "August 18",
          "August 19",
          "August 20",
          "August 21"
        ]
      },
      data7: {
        zh: [
          "8月'01",
          "8月'03",
          "8月'05",
          "8月'07",
          "8月'09",
          "8月'11",
          "8月'13",
          "8月'15",
          "8月'17",
          "8月'19",
          "8月'21",
          "8月'23",
          "8月'25",
          "8月'27",
          "8月'29"
        ],
        en: [
          "Aug '01",
          "Aug '03",
          "Aug '05",
          "Aug '07",
          "Aug '09",
          "Aug '11",
          "Aug '13",
          "Aug '15",
          "Aug '17",
          "Aug '19",
          "Aug '21",
          "Aug '23",
          "Aug '25",
          "Aug '27",
          "Aug '29"
        ]
      }
    };
  },
  computed: {
    topDataTop() {
      let topDataTop = [
        {
          title: this.$t("Total annual energy unit"),
          value: { num: "30,218", unit: "", unit1: this.$t("Rmb") },
          text: "",
          subtext: "",
          imgurl: require("./dollar.png")
        },
        {
          title: this.$t("UN power saving income"),
          value: { num: "13,860", unit: "", unit1: this.$t("Rmb") },
          text: this.$t("Total power saving"),
          subtext: "27,720 kWh ",
          imgurl: require("./dengpao.png")
        },
        {
          title: this.$t("UN CO2 emission benefit"),
          value: { num: "1,358", unit: "", unit1: this.$t("Rmb") },
          text: this.$t("Reduced CO2 emissions"),
          subtext: "23.6 " + this.$t("Ton"),
          imgurl: require("./paiqiIcon.png")
        },
        {
          title: this.$t("Predictive maint saves benefits"),
          value: { num: "15,000", unit: "", unit1: this.$t("Rmb") },
          text: "",
          subtext: "",
          imgurl: require("./setting.png")
        }
      ];
      return topDataTop;
    },
    topData() {
      let topData = [
        {
          title: this.$t("Total cumulative monthly electricity consumption"),
          value: { num: "4,290", unit: "", unit1: "kWh" },
          same: "-14.9",
          sequential: "-6"
        },
        {
          title: this.$t("Total electricity bill for the month"),
          value: { num: "2,450", unit: "", unit1: this.$t("Rmb") },
          same: "-15.3",
          sequential: "-5"
        },
        {
          title: this.$t("Monthly cumulative inhalation"),
          value: { num: "1,030", unit: "", unit1: "Nm³" },
          same: "-14.9",
          sequential: "-3"
        },
        {
          title: this.$t("Monthly aspirated electricity consumption"),
          value: { num: 4.17, unit: "", unit1: "kWh/Nm³" },
          same: "-14.9",
          sequential: "-3"
        },
        {
          title: this.$t("Monthly suction electricity price"),
          value: { num: 2.08, unit: "", unit1: this.$t("Rmb/Nm") },
          same: "-14.9",
          sequential: "-3"
        }
      ];
      return topData;
    },
    legendData6() {
      let legendData6 = [
        this.$t("Screw pump motor"),
        this.$t("Roots pump motor"),
        this.$t("Roots pump motor rated power"),
        this.$t("Screw pump motor rated power")
      ];
      return legendData6;
    },
    legendData7() {
      let legendData7 = [this.$t("Rated power"), this.$t("Actual power")];
      return legendData7;
    }
  },
  watch: {
    "$i18n.locale": {
      handler(val) {
        chart6("chart6", this.legendData6, this.data6[val]);
        chart7("chart7", this.legendData7, this.data7[val]);
      },
      deep: true
    }
  },

  mounted() {
    chart6("chart6", this.legendData6, this.data6[this.$i18n.locale || "ch"]);
    chart7("chart7", this.legendData7, this.data7[this.$i18n.locale || "ch"]);
  }
};
</script>
<style scoped lang="scss">
.info-bg {
  background: #f3f6f9;
}
</style>
